import { Component, inject, Input, OnInit } from '@angular/core';
import { IProduct } from '../../../../../IProduct';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { DisplayRubriqueStatusComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status/display-rubrique-status.component';
import { DisplayRubriqueStatusOnOffComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-on-off/display-rubrique-status-on-off.component';
import { DisplayRubriqueStatusWithWarningComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-with-warning/display-rubrique-status-with-warning.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CollapseComponent } from '../../../../../../../../components/ecosystems/collapse/collapse.component';
import { IonItem, IonLabel, IonList } from '@ionic/angular/standalone';
import {
  brandOverride,
  getPoolMasterClass,
  isSupportTechnique,
} from '../../../../../../ECoSystemsHelper';
import { P00039 } from '../../../../P00039';
import { getTemperature } from '../../../../../../helper/temperature';
import { transformHourToDayHour } from '../../../../../../helper/horloge';

@Component({
  selector: 'app-p0003601-filtration-statut',
  templateUrl: './p0003601-filtration-statut.component.html',
  styleUrls: ['./p0003601-filtration-statut.component.scss'],
  standalone: true,
  imports: [
    DisplayRubriqueStatusComponent,
    DisplayRubriqueStatusOnOffComponent,
    DisplayRubriqueStatusWithWarningComponent,
    TranslatePipe,
    CollapseComponent,
    IonItem,
    IonLabel,
    IonList,
  ],
})
export class P0003601FiltrationStatutComponent implements OnInit {
  @Input() productClass: IProduct | null = null;

  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private translateService: TranslateService = inject(TranslateService);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  getValue(key: string): number {
    return this.actionStack!.getValue(key);
  }

  transformHourToDayHourLocal(value: number): string {
    return transformHourToDayHour(value, this.translateService);
  }

  presenceProduit(): number {
    return new P00039().hasProduct(
      this.edroNetworkManager.getPoolContext()!.pool!,
      this.productClass!,
    );
  }

  displayContacts(value: number): string {
    let res = ['-', '-', '-', '-'];
    if (((value >> 0) & 0x01) === 1) {
      res[3] = 'H';
    }
    if (((value >> 1) & 0x01) === 1) {
      res[2] = 'M';
    }
    if (((value >> 2) & 0x01) === 1) {
      res[1] = 'L';
    }
    if (((value >> 3) & 0x01) === 1) {
      res[0] = 'S';
    }
    return res.join('');
  }

  getVitesseLabel(value: number): string {
    switch (value) {
      case 0:
        return this.translateService.instant('P0003601.card.status.stop');
      case 1:
        return this.translateService.instant('P0003601.card.status.v1');
      case 2:
        return this.translateService.instant('P0003601.card.status.v2');
      default:
        return this.translateService.instant('P0003601.card.status.max');
    }
  }

  protected readonly isSupportTechnique = isSupportTechnique;
  protected readonly getTemperature = getTemperature;
  protected readonly transformHourToDayHour = transformHourToDayHour;
  protected readonly brandOverride = brandOverride;
}
